/**
 * `accounts` translations, for every locale: the Inventory Accounts view. Its tab label lives in inventory.ts.
 */
export const accounts = {
  mn: {
    accounts: {
      add: 'Бүртгэл нэмэх',
      newTitle: 'Шинэ бүртгэл',
      editTitle: 'Бүртгэл засах',
      platform: 'Платформ',
      email: 'Нэвтрэх и-мэйл',
      holder: 'Эзэмшигч',
      unassigned: 'Хуваарилаагүй',
      shared: 'Хуваарилаагүй / дундын',
      plan: 'Багц',
      cost: 'Сарын төлбөр',
      currency: 'Валют',
      renewal: 'Сунгах огноо',
      status: 'Төлөв',
      statusActive: 'Идэвхтэй',
      statusCancelled: 'Цуцалсан',
      notes: 'Тэмдэглэл',
      noPassword: 'Нууц үгийг энд биш, нууц үгийн менежерт хадгална уу.',
      search: 'И-мэйлээр хайх',
      allPlatforms: 'Бүх платформ',
      everyone: 'Бүх эзэмшигч',
      showCancelled: 'Цуцалсныг харуулах',
      loading: 'Ачаалж байна…',
      loadFailed: 'Бүртгэлийн жагсаалтыг ачаалж чадсангүй.',
      platformsLoadFailed: 'Платформын жагсаалтыг ачаалж чадсангүй.',
      empty: 'Бүртгэл алга. "Бүртгэл нэмэх" дарж эхний бүртгэлээ нэмнэ үү.',
      noMatch: 'Шүүлтүүрт тохирох бүртгэл алга.',
      active: 'Идэвхтэй бүртгэл',
      holders: 'Эзэмшигчид',
      perMonth: '{{cost}} {{currency}}/сар',
      renews: '{{date}}-нд сунгана',
      saved: 'Бүртгэл хадгалагдлаа',
      saveFailed: 'Бүртгэлийг хадгалж чадсангүй:',
      deleted: 'Бүртгэл устгагдлаа',
      deleteFailed: 'Бүртгэлийг устгаж чадсангүй:',
      delete: 'Устгах',
      section: 'Бүртгэлүүд',
      error: {
        platform: 'Платформоо сонгоно уу',
        emailRequired: 'Нэвтрэх и-мэйлээ бичнэ үү',
        emailInvalid: 'И-мэйл хаяг буруу байна (жишээ нь sales@example.com)',
        cost: 'Төлбөр 0 ба түүнээс их, хамгийн ихдээ хоёр орны нарийвчлалтай тоо байна',
        currency: 'Төлбөрийн валютаа сонгоно уу',
      },
    },
  },
  en: {
    accounts: {
      add: 'Add account',
      newTitle: 'New account',
      editTitle: 'Edit account',
      platform: 'Platform',
      email: 'Login email',
      holder: 'Holder',
      unassigned: 'Unassigned',
      shared: 'Unassigned / shared',
      plan: 'Plan',
      cost: 'Monthly cost',
      currency: 'Currency',
      renewal: 'Renewal date',
      status: 'Status',
      statusActive: 'Active',
      statusCancelled: 'Cancelled',
      notes: 'Notes',
      noPassword: 'Store the password in the password manager, not here.',
      search: 'Search by email',
      allPlatforms: 'All platforms',
      everyone: 'All holders',
      showCancelled: 'Show cancelled',
      loading: 'Loading…',
      loadFailed: 'Could not load the accounts.',
      platformsLoadFailed: 'Could not load the platform list.',
      empty: 'No accounts yet. Press "Add account" to add the first one.',
      noMatch: 'No account matches these filters.',
      active: 'Active accounts',
      holders: 'Holders',
      perMonth: '{{cost}} {{currency}}/month',
      renews: 'renews {{date}}',
      saved: 'Account saved',
      saveFailed: 'Could not save the account:',
      deleted: 'Account deleted',
      deleteFailed: 'Could not delete the account:',
      delete: 'Delete',
      section: 'Accounts',
      error: {
        platform: 'Choose the platform',
        emailRequired: 'Enter the login email',
        emailInvalid: 'That is not an email address (for example sales@example.com)',
        cost: 'The cost is a number of 0 or more with at most two decimals',
        currency: 'Choose the currency of the cost',
      },
    },
  },
  ru: {
    accounts: {
      add: 'Добавить аккаунт',
      newTitle: 'Новый аккаунт',
      editTitle: 'Изменить аккаунт',
      platform: 'Платформа',
      email: 'Email для входа',
      holder: 'Владелец',
      unassigned: 'Не назначен',
      shared: 'Не назначен / общий',
      plan: 'Тариф',
      cost: 'Стоимость в месяц',
      currency: 'Валюта',
      renewal: 'Дата продления',
      status: 'Статус',
      statusActive: 'Активен',
      statusCancelled: 'Отменён',
      notes: 'Примечания',
      noPassword: 'Храните пароль в менеджере паролей, а не здесь.',
      search: 'Поиск по email',
      allPlatforms: 'Все платформы',
      everyone: 'Все владельцы',
      showCancelled: 'Показать отменённые',
      loading: 'Загрузка…',
      loadFailed: 'Не удалось загрузить аккаунты.',
      platformsLoadFailed: 'Не удалось загрузить список платформ.',
      empty: 'Аккаунтов пока нет. Нажмите «Добавить аккаунт», чтобы добавить первый.',
      noMatch: 'Нет аккаунтов по этим фильтрам.',
      active: 'Активные аккаунты',
      holders: 'Владельцы',
      perMonth: '{{cost}} {{currency}}/мес.',
      renews: 'продление {{date}}',
      saved: 'Аккаунт сохранён',
      saveFailed: 'Не удалось сохранить аккаунт:',
      deleted: 'Аккаунт удалён',
      deleteFailed: 'Не удалось удалить аккаунт:',
      delete: 'Удалить',
      section: 'Аккаунты',
      error: {
        platform: 'Выберите платформу',
        emailRequired: 'Введите email для входа',
        emailInvalid: 'Это не адрес email (например, sales@example.com)',
        cost: 'Стоимость — число от 0, не более двух знаков после запятой',
        currency: 'Выберите валюту стоимости',
      },
    },
  },
}
